import styled from "styled-components";
import Variables from "../../assets/styleVariables";

export const ToolsTop = styled.div`
  margin: 25px 35px;
`;

export const ToolsBody = styled.div`
  margin-left: 10px;
  border-top: 1px solid ${Variables.colors.complementary_500};

  table td {
    cursor: pointer;
    &.name {
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      max-width: 500px;
    }
  }
`;

export const Container = styled.div`
  max-width: 850px;
  margin: auto;
`;

export const SwitchArea = styled.div`
  display: flex;
  align-items: center;
  span {
    margin-left: 16px;
    color: ${Variables.colors.complementary_800};
  }
`;

export const InputsBox = styled.div`
  padding-bottom: 15px;
  padding-left: 5px;
  min-height: 260px;
  max-height: 450px;
  overflow-y: ${props => props.overflowY};
`;

export const ButtonsWrapper = styled.div`
  display: ${props => (props.hide ? "none" : "flex")};
  justify-content: flex-end;
  margin-left: ${props => (props.margin ? "15px" : "")};
  margin-top: 15px;

  & > div {
    margin-left: 10px;

    &:last-child {
      margin-left: 0;
    }
  }
`;

export const Box = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export const FormRow = styled.div`
  display: flex;
  margin-bottom: ${props => (props.marginless ? 0 : "12px")};

  & > div {
    flex: 1;
    margin-left: 10px;

    &:last-child {
      margin-left: 0;
    }
  }
`;

export const FormHelper = styled.div`
  margin-top: 16px;
  max-width: 365px;
  font-size: 12px;
  font-weight: normal;
  line-height: 1.58;
  color: ${Variables.colors.complementary_700};
  margin-right: ${props => (props.pushed ? "200px" : "")};
`;

export const TruncateText = styled.div`
  max-width: ${props => props.width};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const ToolsForm = styled.form`
  width: 100%;
`;

export const FormGroup = styled.div`
  display: flex;
  align-items: center;
  padding: ${props => (props.paddingless ? "0" : "16px")} 0;
  border-bottom: ${props =>
    props.borderless
      ? "none"
      : "1px solid " + Variables.colors.complementary_500};

  &:first-child {
    padding-top: 16px;
  }

  & > label {
    display: flex;
    align-self: flex-start;
    align-items: center;
    padding-top: 12px;
    width: 200px;
    font-size: 12px;
  }

  i.required {
    margin-right: 5px;
    color: ${Variables.colors.red};
    font-size: 10px;
  }
`;

export const FormInput = styled(FormRow)`
  margin: 0;
  flex: 1;
  max-width: 300px;
  margin-right: ${props => (props.pushed ? "200px" : "")};
`;

// TODO: we can use this classes as a universal style for all the project
export const Flex = styled.div`
	position: relative;
	display: flex;
	flex-direction: ${props => {
    switch (props.direction) {
      case "col":
      case "column":
        return "column";
      case "col-reverse":
      case "column-reverse":
        return "column-reverse";
      case "row":
        return "row";
      case "row-reverse":
        return "row-reverse";
      default:
        return "row";
    }
  }};
	${props =>
    props.marginBottom && "margin-bottom: " + props.marginBottom * 10 + "px;"}
	${props => props.marginTop && "margin-top: " + props.marginTop * 10 + "px;"}
	border-color: ${Variables.colors.complementary_400};
	${props =>
    props.borderBottom && "border-bottom: " + (props.borderBottom || 1) + "px;"}
	&:last-child {
		border-bottom: 0;
	}
	justify-content ${props => {
    switch (props.justify) {
      case "between":
        return "space-between";
      case "arround":
        return "space-around";
      case "center":
        return "center";
      case "start":
        return "flex-start";
      case "end":
        return "flex-end";
      default:
        return "space-between";
    }
  }};
	align-items ${props => {
    switch (props.align) {
      case "between":
        return "space-between";
      case "arround":
        return "space-around";
      case "center":
        return "center";
      case "start":
        return "flex-start";
      case "end":
        return "flex-end";
      default:
        return "center";
    }
  }}
`;

export const FlexItem = styled.div`
  display: flex;
  flex: ${props => props.flex || 1};
  margin-left: 5px;

  &:last-child {
    margin-left: 0;
  }
`;

export const Message = styled.p`
  font-size: 12px;
  line-height: 1.58;
  color: ${Variables.colors.complementary_600};
  max-width: ${props => props.maxWidth || "470px"};
`;
